import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { REACT_APP_ARPS_BASE_URL } from "../../utils/urls";

export const baseQuery = fetchBaseQuery({
  baseUrl: REACT_APP_ARPS_BASE_URL,
});

const tagTypes = ["Revenue"];

export const ARPS_API: any = createApi({
  reducerPath: "arps_server",
  refetchOnMountOrArgChange: 30,
  baseQuery: fetchBaseQuery({
    baseUrl: REACT_APP_ARPS_BASE_URL,
    // prepareHeaders: (headers) => {
    //   const accessToken = localStorage.getItem("access_token");
    //   headers.set("Accept", "application/json");
    //   headers.set("Access-Control-Allow-Origin", "true");
    //   if (accessToken) headers.set("authorization", `Bearer ${accessToken}`);
    //   return headers;
    // },
    // credentials: "include",
  }),
  tagTypes: tagTypes,
  endpoints: (builder) => ({}),
  refetchOnFocus: true,
  refetchOnReconnect: false,
});

export const { endpoints, reducerPath, reducer, middleware } = ARPS_API;

export { tagTypes };

export default ARPS_API;
